











import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class DadosBairro extends Vue {
    get bairro () {
        return this.$store.state.cotacao.bairro;
    }

    set bairro ( value ) {
        this.$store.commit("SET_BAIRRO", value);
    }

    get errorBairro () {
        return this.$store.state.errors.bairro;
    }

    public onChange () {
        this.$store.dispatch("VALIDAR_DADOS")
            .then()
            .catch(() => { return; });
    }
}
